module.exports = __webpack_public_path__ + "static/postgresql-f16a2cda4a160e5aafbab5f2aa49c526.svg";